const LOGO_URL = "https://customer-assets.emergentagent.com/job_27ac1c15-2a1f-4f1d-9928-0405b6a7c5e2/artifacts/v5ckfoe3_ChatGPT%20Image%20Jul%207%2C%202026%2C%2004_19_07%20PM.png";

export function Logo({ size = 44, withText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="ufr-logo">
      <div
        className="relative shrink-0 overflow-hidden"
        style={{ width: size, height: size, border: "1px solid rgba(34,255,102,0.45)", borderRadius: 6 }}
      >
        <img
          src={LOGO_URL}
          alt="Ultimate Football Raffles"
          className="absolute inset-0 w-full h-full object-cover"
          draggable={false}
        />
      </div>
      {withText && (
        <div className="leading-none">
          <div className="font-display text-base tracking-wider text-white">UFR</div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-[color:var(--ufr-green)] font-bold">
            Football Raffles
          </div>
        </div>
      )}
    </div>
  );
}
